<template>
    <div class="register_upload" v-loading="isUploadLoading">
        <el-upload
            class="upload-demo"
            action=""
            :accept="accept"
            :before-upload="getUploadInfo"
            :http-request="submitUpload"
            :show-file-list="false">
            <i class="el-icon-upload upload_icon" v-if="uploadDisplayType === 'icon'"></i>
            <el-button class="upload_button" size="small" type="primary" v-if="uploadDisplayType === 'button'">{{text}}</el-button>
            <span class="upload_text" v-if="uploadDisplayType === 'text'" v-html="text"></span>
            <i class="el-icon-upload" v-if="uploadDisplayType === 'iconAndText'"></i>
            <span class="upload_text" v-if="uploadDisplayType === 'iconAndText'" v-html="text"></span>
        </el-upload>
    </div>
</template>

<script>
// import { getInvoiceUpload } from '../../../../api/invo';
// eslint-disable-next-line no-irregular-whitespace
import axios from 'axios';
import config from '@/config/user.env';
export default {
    props: {
        text: {
            type: String,
            default() {
                return '';
            }
        },
        uploadDisplayType: {
            type: String,
            default() {
                return 'icon';
            }
        },
        accept: {
            type: String,
            default() {
                return '';
            }
        },
        flag: {
            type: String,
            default() {
                return '';
            }
        },
        dataUpload: {
            type: Object
        },
        ruleFormData: {
            type: Object
        },
        isDialogLoading: {
            type: Boolean,
            default () {
                return false;
            }
        },
        apApplyObj: {
            type: Object,
            // eslint-disable-next-line vue/require-valid-default-prop
            default: {}
        }
    },
    data() {
        return {
            isUploadLoading: false,
            certification: '',
            contentLength: 0,
            uploadName: '',
            appid: config.uploadAppId,
            appkey: config.uploadAppKey
        };
    },
    methods: {
        getUploadInfo(file) {
            const isPDF = file.type.split('/');
            const isJPG = isPDF[0] === 'image';
            if (!isJPG) {
                this.$message.closeAll();
                this.$message.error('仅支持上传图片');
                return false;
            }
            if (file.size > 10 * 1024 * 1024) {
                this.$message.warning('文件超过限制大小 ' + 10 + 'M！');
                return false;
            }
            const index = file.name.lastIndexOf('.');
            const originName = file.name.substring(0, index);
            const originNameType = file.name.substring(index, file.length);
            this.uploadName = originName + '_' + new Date().getTime() + originNameType;
            this.contentLength = file.size;
            return true;
        },
        submitUpload(uploadData) {
            this.simpleUpload(uploadData);
        },
        async simpleUpload(uploadData) {
            this.$emit('update:isDialogLoading', true);
            const file = new File([uploadData.file], uploadData.file.name, {
                type: uploadData.file.type
            });
            const name = uploadData.file.name;
            const formData = new FormData();
            formData.append('file', file);
            formData.append('businessId', this.apApplyObj.jobId);
            formData.append('systemSource', '10');
            formData.append('moduleCode', 'EfApApplyEditor');
            formData.append('billNo_AA', this.apApplyObj.apApplyNo);
            this.isUploadLoading = true;
            this.ruleFormData.photograph = '';
            this.ruleFormData.invoiceNumber = '';
            this.ruleFormData.invoiceNo = '';
            this.ruleFormData.billingDate = '';
            this.ruleFormData.invoiceAmount = '';
            this.ruleFormData.taxNo = '';
            this.ruleFormData.name = '';
            // axios.post('url',data).then(res=>{})
            axios.post('/api-bms-web/efapBill/invoiceUpload', formData).then(res => {
                if (res && res.code === '0') {
                    if (res.data.success === 'false') {
                        this.$emit('uploadWarning', { data: res.data, name: name, flag: this.flag });
                        this.isUploadLoading = false;
                        this.$emit('update:isDialogLoading', false);
                        return this.$message.error(res.msg);
                    } else {
                        this.isUploadLoading = false;
                        this.$emit('update:isDialogLoading', false);
                        this.$message.success('上传成功');
                        this.$emit('uploadSuccess', { data: res.data, name: name, flag: this.flag });
                    }
                } else {
                    this.isUploadLoading = false;
                    if (res.data) {
                        this.$emit('uploadWarning', { data: res.data, name: name, flag: this.flag });
                    }
                    this.$emit('update:isDialogLoading', false);
                    return this.$message.error(res.msg);
                }
                this.isUploadLoading = false;
                this.$emit('update:isDialogLoading', false);
                this.$emit('uploadError', { data: {} });
            }).catch(() => { this.isUploadLoading = false; this.$emit('update:isDialogLoading', false); });
        }
        //     axios({
        //         method: 'post',
        //         url: `/api-srm-web/efapBill/invoiceUpload`,
        //         data: formData
        //         // headers: {
        //         //     'X-Requested-With': 'XMLHttpRequest',
        //         //     'Concent-Type': 'application/x-www-form-urlencoded;charset=utf-8'
        //         // }
        //     }).then(res => {
        //         debugger;
        //         if (res && res.code === '0') {
        //             if (res.data.success === 'false') {
        //                 this.$emit('uploadWarning', { data: res.data, name: name, flag: this.flag });
        //                 this.isUploadLoading = false;
        //                 this.$emit('update:isDialogLoading', false);
        //                 return this.$message.error(res.msg);
        //             } else {
        //                 this.isUploadLoading = false;
        //                 this.$emit('update:isDialogLoading', false);
        //                 this.$message.success('上传成功');
        //                 this.$emit('uploadSuccess', { data: res.data, name: name, flag: this.flag });
        //             }
        //         } else {
        //             debugger;
        //             console.log(res.data);
        //             this.$emit('uploadWarning', { data: res.data, name: name, flag: this.flag });
        //             this.isUploadLoading = false;
        //             this.$emit('update:isDialogLoading', false);
        //             return this.$message.error(res.msg);
        //         }
        //         this.isUploadLoading = false;
        //         this.$emit('update:isDialogLoading', false);
        //         this.$emit('uploadError', { data: {} });
        //     }).catch(() => { this.isUploadLoading = false; this.$emit('update:isDialogLoading', false); });
        // }
    //         getInvoiceUpload(formData).then(res => {
    //             alert('===========');
    //             if (res && res.code === '0') {
    //                 if (res.data.success === 'false') {
    //                     this.$emit('uploadWarning', { data: res.data, name: name, flag: this.flag });
    //                     this.isUploadLoading = false;
    //                     this.$emit('update:isDialogLoading', false);
    //                     return this.$message.error(res.msg);
    //                 } else {
    //                     this.isUploadLoading = false;
    //                     this.$emit('update:isDialogLoading', false);
    //                     this.$message.success('上传成功');
    //                     this.$emit('uploadSuccess', { data: res.data, name: name, flag: this.flag });
    //                 }
    //             } else {
    //                 alert('============上传结束else=============');
    //                 this.$emit('uploadWarning', { data: res.data, name: name, flag: this.flag });
    //                 this.isUploadLoading = false;
    //                 this.$emit('update:isDialogLoading', false);
    //                 return this.$message.error(res.msg);
    //             }
    //             this.isUploadLoading = false;
    //             this.$emit('update:isDialogLoading', false);
    //             this.$emit('uploadError', { data: {} });
    //         }).catch(() => { this.isUploadLoading = false; this.$emit('update:isDialogLoading', false); });
    //     }
    // }
    }
};
</script>

<style lang="less">
    .register_upload {
        .upload-demo{
            width: 80%;
        }
    }
</style>
